import { Stack } from '@mui/material';
import { Share } from '../../../Share';
import { ReferralRequest } from './ReferralRequest';
import { useNavigate } from 'react-router-dom';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';

interface IRequestSharePanel {
  data: ITherapySuppliersResult;
}

export const RequestSharePanel = ({ data }: IRequestSharePanel) => {
  const navigate = useNavigate();

  const requestHandler = (event: React.MouseEvent) => {
    navigate('/universalRequest/1/1/77');
  };

  return (
    <Stack direction='row' alignItems='center' width='fit-content' gap='16px'>
      <ReferralRequest onClick={requestHandler} />
      <Share />
    </Stack>
  );
};
